<template>
    <Fragment v-if="app.currentConfiguration">
        <Fragment v-if="helper.esSuelo()">
            <!-- altura_suelo_nivel1 -->
            <editParameterValueComponent v-if="nivel == 1" ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['altura_suelo_nivel1']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['altura_suelo_nivel1'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>

            <!-- altura_suelo_nivel2 -->
            <editParameterValueComponent v-else-if="nivel == 2" ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['altura_suelo_nivel2']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['altura_suelo_nivel2'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>

            <!-- altura_suelo_nivel3 -->
            <editParameterValueComponent v-else-if="nivel == 3" ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['altura_suelo_nivel3']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['altura_suelo_nivel3'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>
        </Fragment>

        <Fragment v-if="helper.esTecho()">
            <!-- altura_techo_nivel1 -->
            <editParameterValueComponent v-if="nivel == 1" ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['altura_techo_nivel1']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['altura_techo_nivel1'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>

            <!-- altura_techo_nivel2 -->
            <editParameterValueComponent v-else-if="nivel == 2" ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['altura_techo_nivel2']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['altura_techo_nivel2'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>

            <!-- altura_techo_nivel3 -->
            <editParameterValueComponent v-else-if="nivel == 3" ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="app.currentConfiguration.commonMainElementParameters['altura_techo_nivel3']"
                :prop_title_show="true"
                :value.sync="app.currentConfiguration.commonMainElementParameters['altura_techo_nivel3'].value"
                @update:value="refreshParameters">
            </editParameterValueComponent>
        </Fragment>
    </Fragment>
</template>
<script>
import editParameterValueComponent from '@/components/editParameterValue.vue'
import { Fragment } from 'vue-fragment'
import G60Helper from './G60Helper.js'
import { app } from "../../../application.js";

export default {
    name: "alturasComponent",
    props: {
        nivel: Number
    },
    data() {
        return {
            app: app,
            helper: new G60Helper(app)
        }
    },
    components: {
        editParameterValueComponent,
        Fragment
    },
    computed: {
        isMobile() {
            return this.app.isMobile;
        }
    },
    methods: {
        async refreshParameters() {
            this.$emit('update:value')
        }
    }
}
</script>